import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { withStyles } from "@mui/styles";
import { injectIntl } from "react-intl";
import Typography from "@mui/material/Typography";
import TableCompanyHR from "../../../../components/hr/company/TableCompanyHR";
import { appActions, coverageActions } from "../../../../actions";
import { bindActionCreators } from "redux";
import SimpleMessageDialog from "../../../../components/SimpleMessageDialog";

class ClientAndPolicyListingListCompanyHR extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopupMessage: true,
      isNewPopup: new Date() < new Date('2027-01-01T00:00:00+08:00'),
    };
  }

  goToPage = (company, policyNumber, companyId, productCode) => {
    this.props.history.push(`/auth/claimAndPolicyListing/detail`, { company, policyNumber, companyId, productCode });
  };

  handleClosePopupMessage() {
    this.setState({ showPopupMessage: false });
    this.props.appActions.setAfterLoginPopupVisibility(false);
  }

  render() {
    const { classes, showClientPolicyPopup } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="h5" fontWeight={700}>
          Client and Policy Listing
        </Typography>
        <Typography mt={3}>
          View all your clients policy information via the <span className={classes.subText}>Policy Number</span> or{" "}
          <span className={classes.subText}>Company Name</span>
        </Typography>
        <TableCompanyHR goToPage={this.goToPage} clients={this.props.clients} />
        {!showClientPolicyPopup ? (
          ""
        ) : (
          <SimpleMessageDialog
            title="Notification"
            name="info"
            closeButtonText="OK"
            closeHandler={this.handleClosePopupMessage.bind(this)}
            url={
              this.state.isNewPopup
                ? "https://forms.office.com/r/xjvUySZ0JZ"
                : "https://www.prudential.com.sg/enterprise/employee-benefits/value-added-services/health-wellness"
            }
            urlText={
              this.state.isNewPopup
                ? "to redeem complimentary coverage for personal accidents and infectious diseases."
                : "to redeem complimentary and exclusive lifestyle benefits by Prudential."
            }
            open={this.state.showPopupMessage}
          />
        )}
      </div>
    );
  }
}

const styles = theme => ({
  root: {
    height: "100%",
    paddingTop: "40px",
    paddingLeft: "40px",
    paddingRight: "40px"
  },
  subText: {
    fontWeight: "bold"
  }
});

function mapStateToProps(state) {
  return {
    clients: state.HR.clientsAndPolicyListing.clients,
    products: state.products,
    showClientPolicyPopup: state.app.showClientPolicyPopup
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(coverageActions, dispatch),
    appActions: bindActionCreators(appActions, dispatch)
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(injectIntl(withStyles(styles, { withTheme: true })(ClientAndPolicyListingListCompanyHR)))
);
